import { Component } from '@angular/core';

@Component({
  selector: 'app-form-file-demo',
  templateUrl: './form-file-demo.component.html',
  styleUrls: ['./form-file-demo.component.scss'],
})
export class FormFileDemoComponent {}
